module.exports = __webpack_public_path__ + "img/桑白皮.96509da4.jpg";